import TableData from '../../../components/ui/TableData'
import { useGetBooksBorow } from '../../../service/BookBorrowServiceNew' // chú ý export đúng
import { useNav } from '../../../hooks/useNav'
import { PATH } from '../../../data/router_path'
import { Icon } from '@iconify/react'
import { useState } from 'react'
import BookDetailModal from '../book-list/BookDetailModal'
import ExportExcelBookBorrow from './components/ExportExcelBookBorrow'
export default function BookBorrowDataTable({ path }) {
  const [bookBorrowActive, setBookBorrowActive] = useState(null)
  // Lấy data từ hook React Query
  const {
    data: { totalResult = 0, totalPages = 1, currentPage = 0, books = [] } = {},
  } = useGetBooksBorow()
  const navigate = useNav()
  const detailStudent = (uuidBook) => {
    // lưu lên url
    navigate(PATH.BOOK.BORROWERS_PER_BOOK(uuidBook))
    const dataBookBorrow = books.filter(
      (item) => item.getInforFromUUID === uuidBook
    )
    localStorage.setItem('borrowBookInfo', JSON.stringify(dataBookBorrow))
  }
  const columnMapping = [
    { key: 'titleBorrow', value: 'Nhan đề' },
    { key: 'author', value: 'Tác giả' },
    { key: 'borrowCount', value: 'Số lượt mượn' },
    {
      key: 'timeOfBorrow',
      value: (
        <span>
          Thời gian mượn <br />
        </span>
      ),
    },
    { key: 'getInforFromUUID', value: 'Sinh viên đang mượn' },
  ]

  const columnWidths = {
    title: 'w-[10.83vw]',
    author: 'w-[10.83vw]',
    publishYear: 'w-[7.92vw]',
    subject: 'w-[7.92vw]',
    major: 'w-[7.92vw]',
    bookCollections: 'w-[7.92vw]',
    publisher: 'w-[7.92vw]',
    isbn: 'w-[7.92vw]',
    description: 'w-[7.92vw]',
    pages: 'w-[7.92vw]',
    price: 'w-[7.92vw]',
  }

  const actionButtons = [
    {
      title: 'Xem chi tiết',
      icon: (
        <Icon icon="ci:circle-warning" className={'text-2xl text-main-grey'} />
      ),
      onClick: (row) => {
        setBookBorrowActive(row.getInforFromUUID)
      },
      label: 'Xem chi tiết',
    },
  ]
  return (
    <>
      <TableData
        data={books}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        actionButtons={actionButtons}
        path={path}
        dataType="quyển sách"
        currentPage={currentPage + 1} // backend trả 0-based
        pageSize={10}
        totalItems={totalResult}
        totalPages={totalPages}
        detailView={detailStudent}
        extraFunctions={[<ExportExcelBookBorrow />]}
      />
      {bookBorrowActive ? (
        <BookDetailModal
          uuid={bookBorrowActive}
          closeHandler={() => {
            setBookBorrowActive(null)
          }}
        />
      ) : null}
    </>
  )
}
